var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgKeep = function SvgKeep(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0C2632",
    d: "M10.667 3.333V8L11.8 9.133a.67.67 0 0 1 .2.484V10a.65.65 0 0 1-.192.475.65.65 0 0 1-.475.192H8.667v3.9a.65.65 0 0 1-.192.475.65.65 0 0 1-.475.191.65.65 0 0 1-.475-.191.65.65 0 0 1-.192-.475v-3.9H4.667a.65.65 0 0 1-.475-.192A.65.65 0 0 1 4 10v-.383a.7.7 0 0 1 .2-.484L5.333 8V3.333a.65.65 0 0 1-.475-.191.65.65 0 0 1-.191-.475q0-.285.191-.475A.65.65 0 0 1 5.333 2h5.334q.283 0 .475.192a.65.65 0 0 1 .191.475.65.65 0 0 1-.191.475.65.65 0 0 1-.475.191"
  })));
};
export default SvgKeep;